const meta = {
  dashboards: 'Dashboards',
  services: 'Services',
  'enable-events': 'Events',
  slo: {
    display: 'hidden',
  },
};

export default meta;
